import {RxJsonSchema} from 'rxdb';

export const GoalsSurveySchema: RxJsonSchema | any = {
    "version": 0,
    "type": "object",
    "title": "User Goals Survey",
    "properties": {
        "date": {
            "type": "string"
        },
        "answerMap": {
            "type": "array",
            "unique items": "true",
            "items": {
                "type": "object",
                "goalId": "string",
                "rating": "number"
            }
        },
    },
    "required": [
        "date",
        "answerMap",
    ],
};
